import React from "react";
import Sidebar from "../../../frontend/DesignSystem/Sidebar";
import { useEffect, useState } from "react";
import { db } from "../../../backend/firebaseConfig"; // Ensure correct Firestore import
import { collection, getDoc, doc } from "firebase/firestore";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import "../../../css/Compliance/MembersHub/MembersHubActivity.css";

const MembersHubActivity = () => {
  const [activityLogs, setActivityLogs] = useState([]);

  useEffect(() => {
    const fetchActivityLogs = async () => {
      try {
        const docRef = doc(db, "Compliance", "Members Hub");
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          const data = docSnap.data();
          setActivityLogs(data.activity || []);
        } else {
          // console.log("No activity data found.");
        }
      } catch (error) {
        // console.error("Error fetching activity logs:", error);
      }
    };

    fetchActivityLogs();
  }, []);
  return (
    <div className="Main-Page">
      <Sidebar />
      <div className="MemberHubActivityContainer">
        <h2>Members Hub Activity</h2>
        <table>
          <thead>
            <tr>
              <th>
                <div className="Content-Large">Folder</div>
              </th>
              <th>
                <div className="Content-Large">Files</div>
              </th>
              <th>
                <div className="Content-Large">Action</div>
              </th>
              <th>
                <div className="Content-Large">Posted By</div>
              </th>
              <th>
                <div className="Content-Large">Posted On</div>
              </th>
              <th>
                <div className="Content-Large">View</div>
              </th>
            </tr>
          </thead>
          <tbody>
            {activityLogs.length > 0 ? (
              activityLogs.map((log, index) => (
                <tr key={index}>
                  <td>
                    <div className="Content">{log.folder}</div>
                  </td>
                  <td>
                    <div className="Content">
                      {log.files.map((file, i) => (
                        <div key={i}>{file}</div>
                      ))}
                    </div>
                  </td>
                  <td>
                    <div className="Content">{log.action}</div>
                  </td>
                  <td>
                    <div className="Content">{log.postedBy}</div>
                  </td>
                  <td>
                    <div className="Content">
                      {new Date(
                        log.postedOn.seconds * 1000
                      ).toLocaleDateString()}{" "}
                      <br />
                      {new Date(log.postedOn.seconds * 1000).toLocaleTimeString(
                        [],
                        {
                          hour: "2-digit",
                          minute: "2-digit",
                          second: "2-digit",
                          hour12: true,
                        }
                      )}
                    </div>
                  </td>
                  <td>
                    <div className="Content">
                      <a
                        href={
                          "https://console.firebase.google.com/u/1/project/rosemount-financial-solu-4f940/storage/rosemount-financial-solu-4f940.appspot.com/files"
                        } // Replace with actual link
                        target="_blank"
                        rel="noreferrer"
                        className="View"
                      >
                        <FontAwesomeIcon className="notes-icon" icon={faEye} />
                      </a>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6">
                  <div className="Content-SemiBold">No activity recorded</div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default MembersHubActivity;
